var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOntimeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 152.6 38.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #2900ff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.94,26.14c-3.85,0-6.13-3.34-6.13-7.14,0-1.99,.55-3.68,1.61-5.07,1.1-1.39,2.62-2.07,4.52-2.07s3.42,.68,4.48,2.07c1.1,1.39,1.65,3.09,1.65,5.07,0,3.8-2.28,7.14-6.13,7.14m0-18.13c-6.34,0-10.48,4.94-10.48,10.99s4.14,10.99,10.48,10.99,10.48-4.94,10.48-10.99-4.14-10.99-10.48-10.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.07,8.5h-6.42v3.7h4.26V29.51h4.27V10.61c0-1.17-.94-2.11-2.11-2.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.74,17.25l-3.35-.53c-1.75-.24-3.22-.73-3.22-2.53s1.55-2.82,4.45-2.82c3.3,0,5.22,1.27,6.32,2.53l2.49-2.61c-1.92-2.08-4.73-3.31-8.65-3.31-5.39,0-8.98,2.29-8.98,6.57s3.71,5.51,7.02,6l3.35,.53c1.8,.24,3.22,.73,3.22,2.53,0,2.08-1.96,3.02-4.82,3.02-3.14,0-5.39-1.1-7.22-3.1l-2.73,2.45c2,2.45,5.35,4.04,9.87,4.04,5.75,0,9.26-2.57,9.26-6.82s-3.67-5.47-7.02-5.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80.34,5c1.38,0,2.5-1.12,2.5-2.5s-1.12-2.5-2.5-2.5-2.5,1.12-2.5,2.5,1.12,2.5,2.5,2.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123.68,26.14c-2.43,0-3.67-1.51-3.67-4.54V12.2h8.17v-3.7h-8.17V2.3h-4.08v3.17h0v1.7c-.05,.74-.65,1.32-1.4,1.32h-3.84v3.7h5.24v9.96c0,4.98,3.03,7.88,7.76,7.88,2.49,0,4.45-.84,5.95-1.97l-2.25-3.22c-.67,.68-2.26,1.29-3.7,1.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.26,26.35c-3.57,0-5.75-3.47-5.75-7.39s2.22-7.3,5.75-7.3,5.67,3.35,5.67,7.35-2.13,7.35-5.67,7.35m5.87-14.82c-1.11-2.28-3.65-3.55-6.82-3.55-5.63,0-9.16,4.93-9.16,11.13s3.49,10.94,9.16,10.94c2.96,0,5.54-1.1,6.82-3.55v2.72c-.09,3.42-1.98,5.7-5.73,5.7-2.8,0-4.67-1.04-5.41-3.02l-3.61,1.95c1.5,2.88,4.64,4.51,8.97,4.51,5.99,0,9.87-3.69,9.87-9.16V8.49h-4.11v3.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.1,25.61c-2.43,0-3.62-1.51-3.62-4.54V3.81c0-1.3-1.05-2.35-2.35-2.35H0v3.62H5.33V21.63c0,4.98,3.03,7.88,7.77,7.88h9.17v-3.9H13.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M142.62,11.63c3.49,0,5.67,3.35,5.67,7.35s-2.14,7.35-5.67,7.35-5.75-3.47-5.75-7.39,2.22-7.31,5.75-7.31m-.94,18.4c2.96,0,5.54-1.1,6.82-3.55v2.72c0,.1-.01,.19-.02,.28h4.12c0-.1,0-.21,0-.32V8.46h-4.11v3.05c-1.11-2.29-3.66-3.55-6.82-3.55-5.63,0-9.16,4.93-9.16,11.13s3.49,10.94,9.16,10.94"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOntimeLogo);
export default __webpack_public_path__ + "static/media/ontime-logo.893b1dba6fb66dc15455a4d1fcc55b44.svg";
export { ForwardRef as ReactComponent };